import React, { useState } from 'react';
import PropTypes from 'prop-types';
import css from './FAQ.module.css';

const FAQ = ({ faq }) => {
    if (!faq || faq.length === 0) return null;
    const [open, setOpen] = useState(0);

    return (
        <div className={css.panel}>
            <h4 className={css.heading}>Frequently Asked Questions</h4>
            <div className={css.faqList}>
                {faq.map((item, i) => (
                    <div key={i} className={css.faqItem}>
                        <div
                            className={`${css.question} ${open === i ? css.open : ''}`}
                            onClick={() => setOpen(open === i ? -1 : i)}
                        >
                            {item.question}
                            <span className={css.arrow}>{open === i ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.9999 10.8284L7.0502 15.7782L5.63599 14.364L11.9999 8L18.3639 14.364L16.9497 15.7782L11.9999 10.8284Z" fill="#535862" />
                            </svg>
                                : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.9999 13.1714L16.9497 8.22168L18.3639 9.63589L11.9999 15.9999L5.63599 9.63589L7.0502 8.22168L11.9999 13.1714Z" fill="#535862" />
                                </svg>
                            }</span>
                        </div>
                        {open === i && (
                            <div className={css.answer}>
                                {item.answer}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

FAQ.propTypes = {
    faq: PropTypes.arrayOf(PropTypes.shape({
        question: PropTypes.string.isRequired,
        answer: PropTypes.string.isRequired,
    })),
};

export default FAQ; 